import { render, staticRenderFns } from "./DemoSimpleTableBasic.vue?vue&type=template&id=4576807e&"
import script from "./DemoSimpleTableBasic.vue?vue&type=script&lang=js&"
export * from "./DemoSimpleTableBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../landing-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
